import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  {
    label: 'Features',
    children: [
      { label: 'All Features', path: '/features', icon: '⚡' },
      { label: 'AI Assessment', path: '/features/ai-assessment', icon: '🧠' },
      { label: 'Remote Desktop', path: '/features/remote-desktop', icon: '🖥️' },
      { label: 'Neural Driver', path: '/features/neural-driver', icon: '🔮' },
      { label: 'Screen Capture', path: '/features/screen-capture', icon: '📸' },
    ]
  },
  {
    label: 'Alternatives',
    children: [
      { label: 'vs CodeTantra', path: '/alternatives/codetantra', icon: '🔄' },
      { label: 'vs Mercer Mettl', path: '/alternatives/mercer-mettl', icon: '🔄' },
      { label: 'vs LPU NEST', path: '/alternatives/lpu-nest', icon: '🔄' },
      { label: 'vs Neo Browser', path: '/alternatives/neo-browser', icon: '🔄' },
      { label: 'vs Duolingo', path: '/alternatives/duolingo', icon: '🔄' },
      { label: 'vs Safe Exam Browser', path: '/alternatives/safe-exam-browser', icon: '🔄' },
      { label: 'vs LockDown Browser', path: '/alternatives/lockdown-browser', icon: '🔄' },
    ]
  },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Download', path: '/download' },
  {
    label: 'Resources',
    children: [
      { label: 'Blog', path: '/blog/best-ai-study-tools-2026', icon: '📝' },
      { label: 'FAQ', path: '/faq', icon: '❓' },
      { label: 'For Students', path: '/use-cases/students', icon: '🎓' },
      { label: 'For Developers', path: '/use-cases/developers', icon: '💻' },
    ]
  },
  { label: 'Partners', path: '/partners' },
];

export default function SEONavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setOpenDropdown(null);
  }, [location.pathname]);

  const toggleDropdown = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  return (
    <>
      <style>{`
        .snav {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          padding: 0 24px;
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          background: ${scrolled ? 'rgba(7, 7, 13, 0.92)' : 'transparent'};
          backdrop-filter: ${scrolled ? 'blur(20px)' : 'none'};
          -webkit-backdrop-filter: ${scrolled ? 'blur(20px)' : 'none'};
          border-bottom: 1px solid ${scrolled ? 'rgba(99, 102, 241, 0.08)' : 'transparent'};
        }
        .snav-inner {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: ${scrolled ? '64px' : '76px'};
          transition: height 0.35s ease;
        }
        .snav-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
          font-weight: 800;
          font-size: 1.15rem;
          color: #e4e6f0;
          letter-spacing: -0.02em;
        }
        .snav-logo-icon {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          background: linear-gradient(135deg, #6366f1, #06b6d4);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          color: white;
          font-weight: 900;
        }
        .snav-links {
          display: flex;
          align-items: center;
          gap: 4px;
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .snav-item {
          position: relative;
        }
        .snav-link {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 16px;
          color: #9ba0c2;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 500;
          border-radius: 8px;
          transition: all 0.25s ease;
          cursor: pointer;
          border: none;
          background: none;
          font-family: inherit;
          white-space: nowrap;
        }
        .snav-link:hover, .snav-link.active {
          color: #e4e6f0;
          background: rgba(99, 102, 241, 0.08);
        }
        .snav-link .snav-chevron {
          font-size: 0.6rem;
          transition: transform 0.25s ease;
        }
        .snav-item.open .snav-chevron {
          transform: rotate(180deg);
        }
        .snav-dropdown {
          position: absolute;
          top: calc(100% + 8px);
          left: 50%;
          transform: translateX(-50%) translateY(-8px);
          min-width: 220px;
          background: rgba(17, 17, 32, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(99, 102, 241, 0.12);
          border-radius: 12px;
          padding: 8px;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transition: all 0.25s ease;
          box-shadow: 0 8px 40px rgba(0, 0, 0, 0.4);
          list-style: none;
        }
        .snav-item.open .snav-dropdown {
          opacity: 1;
          visibility: visible;
          pointer-events: all;
          transform: translateX(-50%) translateY(0);
        }
        .snav-dropdown a {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          color: #9ba0c2;
          text-decoration: none;
          font-size: 0.88rem;
          font-weight: 500;
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        .snav-dropdown a:hover {
          color: #e4e6f0;
          background: rgba(99, 102, 241, 0.1);
        }
        .snav-dropdown a .dd-icon {
          font-size: 1rem;
        }
        .snav-hamburger {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 8px;
          background: none;
          border: none;
          z-index: 1002;
        }
        .snav-hamburger span {
          display: block;
          width: 22px;
          height: 2px;
          background: #e4e6f0;
          border-radius: 2px;
          transition: all 0.3s ease;
        }
        .snav-hamburger.open span:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }
        .snav-hamburger.open span:nth-child(2) { opacity: 0; }
        .snav-hamburger.open span:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }
        .snav-mobile-overlay {
          display: none;
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          z-index: 999;
        }
        .snav-mobile-panel {
          display: none;
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          width: 300px;
          background: #0c0c16;
          border-left: 1px solid rgba(99, 102, 241, 0.1);
          z-index: 1001;
          padding: 80px 24px 24px;
          overflow-y: auto;
          transform: translateX(100%);
          transition: transform 0.35s ease;
        }
        .snav-mobile-panel.open { transform: translateX(0); }
        .snav-mobile-panel ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .snav-mobile-panel > ul > li { margin-bottom: 4px; }
        .snav-mobile-panel .snav-link {
          width: 100%;
          padding: 12px 16px;
          font-size: 0.95rem;
        }
        .snav-mobile-panel .snav-dropdown {
          position: static;
          transform: none;
          background: rgba(99, 102, 241, 0.04);
          border: none;
          box-shadow: none;
          margin: 4px 0 8px 8px;
          padding: 4px;
        }
        .snav-mobile-panel .snav-item.open .snav-dropdown {
          transform: none;
        }
        @media (max-width: 900px) {
          .snav-links { display: none; }
          .snav-hamburger { display: flex; }
          .snav-mobile-overlay.open { display: block; }
          .snav-mobile-panel { display: block; }
        }
      `}</style>

      <nav className="snav" role="navigation" aria-label="Main navigation">
        <div className="snav-inner">
          <Link to="/" className="snav-logo" aria-label="CheckScript AI Home">
            <div className="snav-logo-icon">CS</div>
            CheckScript AI
          </Link>

          <ul className="snav-links">
            {navLinks.map(item => (
              <li 
                key={item.label} 
                className={`snav-item ${item.children && openDropdown === item.label ? 'open' : ''}`}
                onMouseEnter={() => item.children && setOpenDropdown(item.label)}
                onMouseLeave={() => item.children && setOpenDropdown(null)}
              >
                {item.children ? (
                  <>
                    <button 
                      className="snav-link" 
                      onClick={() => toggleDropdown(item.label)}
                      aria-expanded={openDropdown === item.label}
                      aria-haspopup="true"
                    >
                      {item.label} <span className="snav-chevron">▼</span>
                    </button>
                    <ul className="snav-dropdown" role="menu">
                      {item.children.map(child => (
                        <li key={child.path} role="none">
                          <Link to={child.path} role="menuitem">
                            <span className="dd-icon">{child.icon}</span>
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link 
                    to={item.path} 
                    className={`snav-link ${location.pathname === item.path ? 'active' : ''}`}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>

          <button 
            className={`snav-hamburger ${mobileOpen ? 'open' : ''}`} 
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <div 
        className={`snav-mobile-overlay ${mobileOpen ? 'open' : ''}`} 
        onClick={() => setMobileOpen(false)} 
      />

      {/* Mobile Panel */}
      <div className={`snav-mobile-panel ${mobileOpen ? 'open' : ''}`}>
        <ul>
          {navLinks.map(item => (
            <li 
              key={item.label} 
              className={`snav-item ${item.children && openDropdown === item.label ? 'open' : ''}`}
            >
              {item.children ? (
                <>
                  <button 
                    className="snav-link" 
                    onClick={() => toggleDropdown(item.label)}
                  >
                    {item.label} <span className="snav-chevron">▼</span>
                  </button>
                  <ul className="snav-dropdown">
                    {item.children.map(child => (
                      <li key={child.path}>
                        <Link to={child.path}>
                          <span className="dd-icon">{child.icon}</span>
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link to={item.path} className="snav-link">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
